import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaMobileAlt,
  FaShoppingBag,
  FaTachometerAlt,
  FaUsers,
  FaLock,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MobileFriendlyEcommerceWebsitesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Mobile-Friendly E-commerce Websites in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Optimized for Every Device</Subheading>}
        heading={
          <Heading>
            Mobile-Friendly{" "}
            <span tw="text-primary-500">E-commerce Websites</span> in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in creating mobile-friendly
            e-commerce websites in **Bur Dubai**, ensuring seamless shopping
            experiences on smartphones and tablets. Reach your customers
            wherever they are with responsive, high-performing online stores.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping experience
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce development
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Customer using mobile shopping app
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Go Mobile Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Mobile-First E-commerce Solutions in Bur Dubai"
        description="We prioritize mobile usability to maximize your reach and sales."
        cards={[
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Design",
            description: "Perfect display on all screen sizes and devices.",
          },
          {
            icon: <FaShoppingBag color="#ff5464" size={40} />,
            title: "Enhanced Shopping",
            description: "Smooth navigation and checkout for mobile users.",
          },
          {
            icon: <FaTachometerAlt color="#ff5464" size={40} />,
            title: "Fast Load Times",
            description: "Optimized for speed on mobile networks.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Wider Audience",
            description: "Capture Bur Dubai’s growing mobile shopper base.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe mobile payments for customer trust.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Expertise",
            description: "Trusted by businesses for mobile excellence.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Process for Mobile-Friendly E-commerce"
        description={
          <Description>
            We craft mobile-optimized e-commerce websites with a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Analyze mobile usage trends in Bur Dubai.</li>
              <li>Design: Create responsive, user-friendly interfaces.</li>
              <li>Development: Build with mobile-first frameworks.</li>
              <li>Testing: Test across devices for flawless performance.</li>
              <li>Optimization: Enhance speed and usability.</li>
              <li>Support: Ensure ongoing mobile compatibility.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile website development
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team collaborating on mobile design
          "https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile responsive testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        sheading="Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Mobile Success in Bur Dubai"
        description="Our mobile-friendly e-commerce websites deliver real results."
        cards={[
          {
            icon: <FaShoppingBag color="#ff5464" size={40} />,
            title: "Mobile Sales Surge",
            description:
              "Increased mobile conversions by 175% for a local retailer.",
          },
          {
            icon: <FaTachometerAlt color="#ff5464" size={40} />,
            title: "Speed Boost",
            description: "Reduced mobile load time by 60% for better UX.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Customer Praise",
            description: "95% satisfaction rate from mobile shoppers.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Go Mobile?</Subheading>}
        heading="Mobile-Friendly E-commerce in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset to create a mobile-friendly e-commerce
            website that captivates Bur Dubai’s on-the-go shoppers. Let’s
            optimize your store for the mobile era!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1586880244406-556ebe35f282?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce success
          "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with person using smartphone
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile payment/checkout
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
